module.exports = __webpack_public_path__ + "static/media/icon_pipeline-tigger.80d9dad2.svg";